import { Configuration } from "./configuration";

const config: Configuration = new Configuration();

export default config;
